import {
    AUTH_LOGIN_REQUEST,
    AUTH_LOGIN_SUCCESS,
    AUTH_LOGIN_FAILURE,
} from './types';


const initialState = {
    
    loading: false,
    error: null,
    auth:[]
    
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case AUTH_LOGIN_SUCCESS:{
            // const {email, password} = action.payload;
            
            return {
                ...state,
                loading: false,
                // payload:action.payload.result,
                auth:action.payload
            }
        }
        case AUTH_LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.message,
            }

        default:
            return state
    }
}

export default authReducer